// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ITransactorAddressInfoDto } from './ITransactorAddressInfoDto';
import {
    ITransactorAddressInfoDtoFromJSON,
    ITransactorAddressInfoDtoFromJSONTyped,
    ITransactorAddressInfoDtoToJSON,
    ITransactorAddressInfoDtoToJSONTyped,
} from './ITransactorAddressInfoDto';
import type { ISourceTransactorActorDto } from './ISourceTransactorActorDto';
import {
    ISourceTransactorActorDtoFromJSON,
    ISourceTransactorActorDtoFromJSONTyped,
    ISourceTransactorActorDtoToJSON,
    ISourceTransactorActorDtoToJSONTyped,
} from './ISourceTransactorActorDto';

/**
 * 
 * @export
 * @interface ITransactorInfoDto
 */
export interface ITransactorInfoDto {
    /**
     * 
     * @type {number}
     * @memberof ITransactorInfoDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ITransactorInfoDto
     */
    name?: string;
    /**
     * 
     * @type {ITransactorAddressInfoDto}
     * @memberof ITransactorInfoDto
     */
    address?: ITransactorAddressInfoDto;
    /**
     * 
     * @type {number}
     * @memberof ITransactorInfoDto
     */
    account_id?: number;
    /**
     * 
     * @type {string}
     * @memberof ITransactorInfoDto
     */
    source_type?: ITransactorInfoDtoSourceTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof ITransactorInfoDto
     */
    transactor_type?: ITransactorInfoDtoTransactorTypeEnum;
    /**
     * 
     * @type {ISourceTransactorActorDto}
     * @memberof ITransactorInfoDto
     */
    source_partner?: ISourceTransactorActorDto;
    /**
     * 
     * @type {ISourceTransactorActorDto}
     * @memberof ITransactorInfoDto
     */
    source_transactor?: ISourceTransactorActorDto;
}

/**
* @export
* @enum {string}
*/
export enum ITransactorInfoDtoSourceTypeEnum {
    WEBSITE = 'WEBSITE',
    PAYMENT_CARD_TRX = 'PAYMENT_CARD_TRX',
    FILE_LOAD = 'FILE_LOAD',
    NONE = 'NONE',
    LOCKBOX = 'LOCKBOX'
}
/**
* @export
* @enum {string}
*/
export enum ITransactorInfoDtoTransactorTypeEnum {
    REPLENISHMENT = 'REPLENISHMENT',
    CONTRIBUTIONS = 'CONTRIBUTIONS',
    ADMINISTRATOR_FEES = 'ADMINISTRATOR_FEES',
    PROVIDER = 'PROVIDER',
    CARD_ACCEPTOR = 'CARD_ACCEPTOR',
    REIMBURSEMENT = 'REIMBURSEMENT',
    CARD_PROCESSOR = 'CARD_PROCESSOR',
    SYSTEM = 'SYSTEM',
    VENDOR = 'VENDOR'
}


/**
 * Check if a given object implements the ITransactorInfoDto interface.
 */
export function instanceOfITransactorInfoDto(value: object): value is ITransactorInfoDto {
    return true;
}

export function ITransactorInfoDtoFromJSON(json: any): ITransactorInfoDto {
    return ITransactorInfoDtoFromJSONTyped(json, false);
}

export function ITransactorInfoDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ITransactorInfoDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'address': json['address'] == null ? undefined : ITransactorAddressInfoDtoFromJSON(json['address']),
        'account_id': json['account_id'] == null ? undefined : json['account_id'],
        'source_type': json['source_type'] == null ? undefined : json['source_type'],
        'transactor_type': json['transactor_type'] == null ? undefined : json['transactor_type'],
        'source_partner': json['source_partner'] == null ? undefined : ISourceTransactorActorDtoFromJSON(json['source_partner']),
        'source_transactor': json['source_transactor'] == null ? undefined : ISourceTransactorActorDtoFromJSON(json['source_transactor']),
    };
}

export function ITransactorInfoDtoToJSON(json: any): ITransactorInfoDto {
    return ITransactorInfoDtoToJSONTyped(json, false);
}

export function ITransactorInfoDtoToJSONTyped(value?: ITransactorInfoDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'address': ITransactorAddressInfoDtoToJSON(value['address']),
        'account_id': value['account_id'],
        'source_type': value['source_type'],
        'transactor_type': value['transactor_type'],
        'source_partner': ISourceTransactorActorDtoToJSON(value['source_partner']),
        'source_transactor': ISourceTransactorActorDtoToJSON(value['source_transactor']),
    };
}

